/**
 * MiniLogo.js
 */

import $ from 'jquery';
import Utilities from './Utilities';

class MiniLogo {

    constructor() {

		$(window).scroll(function (event) {
		    var scroll = $(window).scrollTop();

			var x = $('.header-logo').position().top + $('.header-logo').height()

			if ( scroll > x ) {
				$('.alny-sites-wrapper').addClass('show-mini');
			} else {
				$('.alny-sites-wrapper').removeClass('show-mini');
			}
		});

    }

}
new MiniLogo();